var App = App || {},
    navOpen = false;

App.Base = (function ($) {
    "use strict";

    var $header = $("header");

    function init() {
        // Anchors
        $(window).on("load", function () {
            var hash = window.location.href.split("#")[1],
                offset = $header.outerHeight();

            if (hash) {
                $(window)
                    .stop(true)
                    .scrollTo($("#" + hash), { duration: 400, interrupt: false, offset: offset * -1 });
            }
        });

        // Animations
        var supportsCssVariables = window.CSS && window.CSS.supports && window.CSS.supports("color", "var(--primary)");

        if (supportsCssVariables) {
            $("body").addClass("supports-css-variables");

            setTimeout(function () {
                var $elements = $(".animate__animated");

                if ($elements.length) {
                    $elements.waypoint({
                        handler: function (direction) {
                            var $element = $(this.element),
                                animation = $element.data("animation");

                            if (animation) {
                                $element
                                    .addClass("animate__" + animation)
                                    .css("visibility", "visible");
                            }
                        },
                        offset: "100%"
                    });
                }
            }, 1);
        }

        // Carousels
        var $carousels = $(".carousel");

        if (supportsCssVariables) {
            $carousels.on("breakpoint", function () {
                var $elements = $(".animate__animated");

                $.each($elements, function () {
                    var $this = $(this),
                        animation = $this.data("animation");

                    if (animation) {
                        $this
                            .addClass("animate__" + animation)
                            .css("visibility", "visible");
                    }
                });
            });
        }

        // Skip links
        var $loginToggle = $(".login-toggle"),
            $loginDropdown = $(".login-dropdown");

        $(".skip.olb").on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();

            if ($loginToggle.length) {
                $loginToggle.dropdown("toggle");

                $loginDropdown
                    .find("input[name='username']")
                    .focus();
            }
        });

        // Smart app banner
        new SmartBanner({
            daysHidden: 15,
            daysReminder: 90,
            appStoreLanguage: "us",
            title: "WCCU eBanking",
            author: "Westerly Community Credit Union",
            button: "View",
            store: {
                ios: "On the App Store",
                android: "In Google Play"
            },
            price: {
                ios: "FREE",
                android: "FREE"
            }
        });

        var $smartbanner = $(".smartbanner"),
            $smartbannerButton = $smartbanner.find(".smartbanner-button"),
            $smartbannerContainer = $(".smartbanner-container");

        $smartbanner.prependTo("section.navigation.mobile");

        $smartbannerButton
            .addClass("btn btn-sm btn-primary")
            .removeClass("smartbanner-button")
            .children("span")
            .removeClass("smartbanner-button-text");

        $smartbannerContainer.addClass("container");

        // Smooth scrolling
        $(document).on("click", "a[href^='#']:not('[data-bs-toggle]'):not('.close'):not('.skip')", function (e) {
            e.preventDefault();

            var self = this,
                $this = $(this);

            smoothScroll(self, $this);
        });

        function smoothScroll(self, $this) {
            if ($this.data("url") === undefined) {
                var offset = 0;

                if ($header.css("position") === "sticky") {
                    offset = $header.outerHeight();
                }

                // Don't trigger smooth scrolling on dropdown menu toggles
                if ($this.attr("href").indexOf("dropdown") < 1) {
                    $(window)
                        .stop(true)
                        .scrollTo(self.hash, { duration: 400, interrupt: false, offset: offset * -1 });
                }
            }
        }

        // Sticky positioning
        var $stickyElements = $("header, .position-sticky, .sticky-top");

        if ($stickyElements.length) {
            Stickyfill.add($stickyElements);
        }

        // Tooltips
        $('[data-bs-toggle="tooltip"]').tooltip({
            container: "body"
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Base.init();
});